export class Forma{
    nome? : string;

    constructor(nome?: string){
        this.nome=nome
    }
}